export type Baseline = {
  companyId: string;
  companyName: string;
  day: number;
  night: number;
};

export type TimePeriod = {
  from: string;
  to: string;
  baselines: Baseline[];
  totalDay?: number;
  totalNight?: number;
  isExpanded?: boolean;
};

export enum MODE {
  VIEW = 'view',
  EDIT = 'edit',
  NONE = ''
}

export type WorkCenterBaseline = {
  id: string | null;
  workCenter: string;
  isSelected: boolean;
  description: string;
  mode: MODE;
  approved: TimePeriod[];
  requested: TimePeriod[];
};

export type WorkCenterBaselineResponse = {
  value: WorkCenterBaseline;
};

export type WorkCenters = {
  workCenters: WorkCenterBaseline[];
};

export enum SHIFT {
  DAY = 'day',
  NIGHT = 'night'
}

export type UpdateBaselinePayload = {
  requested: TimePeriod[];
};

export type AddBaselinePayload = {
  workCenter: string;
  approved: [];
  requested: TimePeriod[];
};

export type BaselinesData = {
  workCenter: string;
  id: string;
  requested: null | TimePeriod[];
  approved: TimePeriod[];
};

export type BaselineWorkCenterDay = {
  date: string;
  day: number;
  night: number;
};

export type BaselineWorkCenterDays = {
  workCenter: string;
  baseline: BaselineWorkCenterDay[];
};
